import React, { ComponentType, useCallback, SyntheticEvent } from 'react';
import { tryInvoke } from '@factorin/util';

import { Portal } from '../Portal';
import { cn, stopPropagation } from '../../utils';
import styles from './index.module.scss';


type ClosingOverlayProps = {
    darken?: boolean;
    zIndex?: number;
    onClose?: () => void;
}

export const ClosingOverlay: ComponentType<ClosingOverlayProps> = ({
    darken, zIndex = 0, onClose, children,
}) => (
    <>
        {children}
        <Portal>
            <div
                role='presentation'
                onClick={useCallback(
                    (e: SyntheticEvent) => {
                        stopPropagation(e);
                        tryInvoke(onClose);
                    },
                    [onClose],
                )}
                style={{ zIndex }}
                className={cn(styles.closingOverlay, {
                    [styles.darken]: darken,
                })}
            />
        </Portal>
    </>
);
